import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { toAppError } from '@/app/core/http/error-catalog';

export interface HospitalAccountExportNotice {
  tone: 'error' | 'warning';
  title: string;
  description: string;
}

const TITLE = 'No pudimos exportar las cuentas hospitalarias';
const ASYNC_DOWNLOAD_UNAVAILABLE = 'ASYNC_DOWNLOAD_UNAVAILABLE';

interface ApiErrorBody {
  error?: { message?: unknown; details?: { reason?: unknown; threshold?: unknown } };
}

export function toHospitalAccountExportNotice(cause: unknown): HospitalAccountExportNotice {
  if (cause instanceof HttpErrorResponse && cause.status === HttpStatusCode.UnprocessableEntity) {
    return { tone: 'warning', title: TITLE, description: tooManyRecordsMessage(cause) };
  }

  if (cause instanceof HttpErrorResponse && cause.status === HttpStatusCode.BadRequest) {
    return {
      tone: 'warning',
      title: TITLE,
      description: 'Revisa los filtros de búsqueda y vuelve a intentarlo.',
    };
  }

  const appError = toAppError(cause, 'las cuentas hospitalarias');
  const description =
    appError.kind === 'forbidden'
      ? 'Tu usuario no está habilitado para exportar cuentas hospitalarias. Contacta al administrador de tu institución.'
      : appError.kind === 'rateLimited'
        ? appError.description
        : 'Ocurrió un problema al generar el archivo. Vuelve a intentarlo en unos minutos.';

  return { tone: appError.kind === 'forbidden' ? 'warning' : 'error', title: TITLE, description };
}

function tooManyRecordsMessage(cause: HttpErrorResponse): string {
  const error = (cause.error as ApiErrorBody | null)?.error;
  const details = error?.details;
  if (details?.reason === ASYNC_DOWNLOAD_UNAVAILABLE && typeof details.threshold === 'number') {
    return `La búsqueda supera el máximo de ${details.threshold.toLocaleString('es-CL')} registros para exportar. Acota los filtros e inténtalo nuevamente.`;
  }
  return typeof error?.message === 'string' && error.message.trim()
    ? error.message
    : 'La búsqueda supera el máximo de registros para exportar. Acota los filtros e inténtalo nuevamente.';
}
